import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("polling"); // polling | paid | failed | timeout

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("failed");
      return;
    }
    let attempts = 0;
    const maxAttempts = 8;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("failed");
          return;
        }
        if (attempts >= maxAttempts) {
          setStatus("timeout");
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        if (attempts >= maxAttempts) setStatus("failed");
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="payment-success-page">
      <div className="max-w-lg w-full bb-card p-12 text-center">
        {status === "polling" && (
          <>
            <Loader2 className="animate-spin mx-auto mb-6" size={56} style={{ color: "var(--bb-primary)" }} />
            <h1 className="bb-display text-4xl mb-3">Verifica pagamento...</h1>
            <p className="text-zinc-400">Attendere prego, stiamo confermando la transazione.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto mb-6" size={64} style={{ color: "var(--bb-primary)" }} />
            <h1 className="bb-display text-4xl mb-3" data-testid="payment-success-title">Iscrizione confermata!</h1>
            <p className="text-zinc-300 leading-relaxed">
              La tua birra è ufficialmente in gara per il Beer Battle.
              Riceverai presto un'email con i dettagli per la consegna delle bottiglie.
            </p>
            <button
              onClick={() => navigate("/")}
              className="bb-btn-primary mt-8"
              data-testid="back-home-btn"
            >
              Torna alla home
            </button>
          </>
        )}
        {(status === "failed" || status === "timeout") && (
          <>
            <XCircle className="mx-auto mb-6" size={64} style={{ color: "#EF4444" }} />
            <h1 className="bb-display text-4xl mb-3">Verifica non riuscita</h1>
            <p className="text-zinc-400">
              {status === "timeout"
                ? "La verifica sta richiedendo più del previsto. Controlla la tua email."
                : "Non siamo riusciti a verificare il pagamento. Contattaci se hai dubbi."}
            </p>
            <button onClick={() => navigate("/")} className="bb-btn-outline mt-8">
              Torna alla home
            </button>
          </>
        )}
      </div>
    </main>
  );
}
